import FieldDimensionId from '@core/constants/FieldDimension';
import { MaterialId } from '@core/constants/Material';
import { LegsShapeId, TvUnitStorageShapeId } from '@core/constants/Shape';
import {
    IDimensionUnit,
    IFormFieldDimension,
    IFormFieldMaterial,
    IFormFieldShape,
    IFormFieldShapeQuantities,
    IFormInputType,
} from '../../../interfaces/Form';
import allMaterials, { allMetals, allWoods, getMaterialsWithExceptions } from './materialGroups';
import { allBorders, allLegs, getLegsWithExceptions } from './shapesGroups';

export const fieldsConsoleMaterial: IFormFieldMaterial = {
    material: {
        value   : undefined,
        options : getMaterialsWithExceptions(allMaterials,
            [
                MaterialId.BlackLocust,
                MaterialId.Iroko,
                MaterialId.Douglas,
                MaterialId.DouglasEngineered,
                MaterialId.DouglasRecycled,
                MaterialId.DouglasVeneer,
                MaterialId.Garapa,
                MaterialId.PlexiglassFluorescent,
                MaterialId.PlexiglassFrosted,
                MaterialId.PlexiglassMirror,
                MaterialId.PlexiglassTransparent,
                MaterialId.PlexiglassWhite,
                MaterialId.PolycarbonateOpaque,
                MaterialId.PolycarbonateTeinted,
                MaterialId.PolycarbonateTransparent,
                MaterialId.Pvc,
                MaterialId.PvcRigid,
            ]),
        required: true,
    },
};

export const fieldsConsoleBorders: IFormFieldShape = {
    value    : undefined,
    options  : allBorders,
    required : true,
};

export const fieldsConsoleLegs: IFormFieldShape = {
    value   : undefined,
    options : getLegsWithExceptions(allLegs,
        [
            LegsShapeId.LegsMikado,
            LegsShapeId.LegsTrapezeCentral,
            LegsShapeId.LegsVShaped,
            LegsShapeId.LegsVShapedCentral,
            LegsShapeId.LegsHarmonious,
            LegsShapeId.LegsGreedy,
        ]),
    required: true,
};

export const fieldsConsoleLegsMaterial: IFormFieldMaterial = {
    material: {
        value   : undefined,
        options : getMaterialsWithExceptions([...allMetals, ...allWoods],
            [
                MaterialId.BlackLocust,
                MaterialId.Iroko,
                MaterialId.Douglas,
                MaterialId.DouglasEngineered,
                MaterialId.DouglasRecycled,
                MaterialId.DouglasVeneer,
                MaterialId.Garapa,
                MaterialId.Zinc,
                MaterialId.Rust,
                MaterialId.ThermoLaqueredBlack,
                MaterialId.ThermoLaqueredWhite,
                MaterialId.StainlessSteel,
            ]),
        required: true,
    },
};

export const fieldsConsoleLegsDimensions: IFormFieldDimension = {
    [FieldDimensionId.Height]: {
        value        : undefined,
        type         : IFormInputType.Range,
        unit         : IDimensionUnit.Centimeters,
        step         : 50,
        range        : { min: 700, max: 1500 },
        required     : true,
        defaultValue : 1200,
    },
};

export const fieldsConsoleOptions: IFormFieldShapeQuantities = {
    [TvUnitStorageShapeId.TvNiche]: {
        value : undefined,
        min   : 0,
        max   : 2,
    },
    [TvUnitStorageShapeId.TvDrawer]: {
        value : undefined,
        min   : 0,
        max   : 2,
    },
};

